import React, { useEffect, useState } from "react";
import RouteList from "Routes/private/list";
import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useStoreState, useStoreActions } from "easy-peasy";
import { truncateStr } from "Utils";

export default function Breadcrumbs({ ...props }) {
  const location = useLocation()?.pathname;

  const { breadcrumbs } = useStoreState((store) => store.app);
  const { setBreadcrumbs } = useStoreActions((store) => store.app);

  useEffect(() => {
    let _breadcrumbs = [];

    const matchRouteInList = (route, parent) => {
      let list = parent?.children || RouteList;

      if (list.length > 0)
        for (let i = 0; i < list.length; i++) {
          if (route === list[i].path || list[i].path.indexOf(":") != -1) {
            let found = {
              ...list[i],
              path: (parent?.path || "") + list[i].path,
            };
            _breadcrumbs.push(found);
            return found || null;
          }
        }
      else return null;
    };
    if (location) {
      let pathParts = location.split("/").filter((f) => f.length > 0);
      let parent = null;
      pathParts.forEach((element) => {
        parent = matchRouteInList("/" + element, parent);
      });
      setBreadcrumbs(_breadcrumbs);
    }
  }, [location, RouteList]);

  return (
    <Breadcrumb
      style={{
        padding: "16px 24px",
        backgroundColor: "#a69d98",
      }}
    >
      {breadcrumbs.map((m) => (
        <Breadcrumb.Item key={m.name}>
          {m.icon ? (
            <FontAwesomeIcon
              icon={[m.icon.library, m.icon.name]}
              style={{ marginRight: 4 }}
            />
          ) : null}
          {m.component ? (
            <Link to={m.path}>{truncateStr(m.name, 26)}</Link>
          ) : (
            truncateStr(m.name, 26)
          )}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
}
